import React from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Menu from "@/components/Menu";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import News from "@/components/News";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import VideoPopup from "@/components/VideoPopup";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Menu />
      <Gallery />
      <Reviews />
      <News />
      <Contact />
      <Footer />
      <VideoPopup />
    </div>
  );
}

export default App;
